'use client';

/**
 * Toast — wrapper Sonner avec thème SEF v3.
 * Usage : import { toast } from '@/components/ui/toast';
 *         toast.success('Dossier enregistré !');
 *
 * Ajouter <Toaster /> une fois dans le layout racine.
 */
export { toast } from 'sonner';

import { Toaster as SonnerToaster } from 'sonner';
import { cn } from '../../lib/cn';

interface ToasterProps {
  className?: string;
}

export function Toaster({ className }: ToasterProps) {
  return (
    <SonnerToaster
      position="bottom-right"
      expand
      richColors
      closeButton
      toastOptions={{
        classNames: {
          toast: cn(
            'group flex items-start gap-3 rounded-xl border border-stone-200 bg-white p-4 shadow-medium',
            'text-[14px] text-ink',
            className,
          ),
          title: 'font-semibold leading-tight',
          description: 'text-[13px] text-stone-500',
          success: '!border-brand-200 !bg-brand-50 !text-brand-900',
          error: '!border-red-200 !bg-red-50 !text-red-900',
          warning: '!border-amber-200 !bg-amber-50 !text-amber-900',
          info: '!border-blue-200 !bg-blue-50 !text-blue-900',
          closeButton:
            'rounded-md p-1 text-stone-400 transition-colors hover:bg-stone-100 hover:text-stone-600 focus-visible:ring-2 focus-visible:ring-brand-500/30',
        },
      }}
    />
  );
}
